// src/pages/ListingsLogin.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebaseConfig'; // Import your Firebase auth instance
import './ListingsLogin.css'; // Link to its dedicated CSS file

const ListingsLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault(); // Prevent default form submission
    setError(''); // Clear previous errors
    setLoading(true); // Show loading state

    try {
      // Attempt to sign in with Firebase Authentication
      await signInWithEmailAndPassword(auth, email, password);
      // On successful login, navigate to the listings dashboard
      navigate('/listingsdashboard'); // Use the route you define for the dashboard
    } catch (err) {
      console.error("Login error:", err);
      // Provide user-friendly error messages based on Firebase error codes
      if (err.code === 'auth/invalid-email' || err.code === 'auth/user-not-found' || err.code === 'auth/wrong-password') {
        setError('Invalid email or password.');
      } else if (err.code === 'auth/user-disabled') {
        setError('This user account has been disabled.');
      } else {
        setError('Failed to log in. Please try again.');
      }
    } finally {
      setLoading(false); // Hide loading state
    }
  };

  return (
    <div className="listings-login-container page-fade-in">
      <div className="login-box">
        <h2>listings Login</h2>
        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label htmlFor="email">Email:</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required // Make input mandatory
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password:</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required // Make input mandatory
            />
          </div>
          {error && <p className="error-message">{error}</p>} {/* Display error messages */}
          <button type="submit" disabled={loading}>
            {loading ? 'Logging In...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ListingsLogin;